import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/public-filter-constants';

export interface Profile {
  authorId: string;
  username: string;
  nickname?: string;
  profileImageUrl: string;
  followerCount: number;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
  platform: SOURCE_PLATFORM_TYPE;
}

export interface ExtendedProfile extends Profile {
  engagementRate: number;
}

export interface Location {
  name: string;
  code: string;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
}

export interface DemographicStat {
  name: string;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
}

export interface Keyword {
  name: string;
  post_volume: number;
}

export interface Hashtag {
  name: string;
  post_volume: number;
}

export enum PostFilter {
  Keyword = 'keyword',
  Hashtag = 'hashtag',
  Profile = 'profile',
}

export type PostFilterMap = { [key in PostFilter]?: string };
